import RegionCreate from "@/views/AdminPanel/RegionCreate.vue";
import RegionsList from "@/views/AdminPanel/RegionsList.vue";
import RegionEdit from "@/views/AdminPanel/RegionEdit.vue";
const routes = [
    {
        path: "/secure/regions",
        name: "RegionsList",
        component: RegionsList,
    },
    {
        path: "/secure/regions/create",
        name: "RegionCreate",
        component: RegionCreate,
    },
    {
        path: "/secure/regions/edit/:region_uuid",
        name: "RegionEdit",
        component: RegionEdit,
    },
];
export default routes;
